export const makeUrl = (domain, subdomain, relativePath) => {    
    let url = `https://${subdomain ? subdomain + '.' : ''}${domain}`;
    
    if (relativePath) {
        url += `/${relativePath.replace(/^\//, '')}`; // Ensure no double slashes
    }
    
    return url;
}

export default makeUrl;